module.exports = __webpack_public_path__ + "img/category_6.7f61f415.svg";